module.exports = __webpack_public_path__ + "img/login-bg.7313d003.jpg";